<template>
  <div class="container-fluid py-4">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-clock-history fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Modification d'une durée de médicament</h2>
      </div>
      <router-link
        class="btn btn-primary btn-lg shadow-sm btn-clinique"
        :to="{ name: 'liste_duree_medicament' }"
      >
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique" v-if="!isLoading">
      <div class="row g-4">
        <!-- Libellé -->
        <div class="col-md-6">
          <label for="nom" class="form-label fw-semibold">Libellé</label>
          <input
            type="text"
            id="nom"
            v-model="duree.nom"
            class="form-control form-control-clinique"
            :class="{ 'is-invalid': error.nom }"
            placeholder="Ex : 5 jours, 2 semaines, 1 mois"
          >
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>

        <!-- Description -->
        <div class="col-md-6">
          <label for="description" class="form-label fw-semibold">Description</label>
          <textarea
            id="description"
            v-model="duree.description"
            class="form-control form-control-clinique"
            rows="3"
            placeholder="Description (optionnel)"
          ></textarea>
        </div>
      </div>

      <!-- Statut -->
      <div class="row g-4 mt-1">
        <div class="col-md-6 d-flex align-items-center">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="enabled"
              v-model="duree.isEnabled"
            >
            <label class="form-check-label ms-2 fw-semibold" for="enabled">
              Activé ?
            </label>
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isLoading" @click="updateDuree">
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>
    </div>

    <div v-else class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
        <span class="visually-hidden">Chargement...</span>
      </div>
      <p class="mt-2">Chargement de la durée...</p>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'EditDuree',
  data() {
    return {
      isLoading: true,
      duree: {
        nom: '',
        description: '',
        isEnabled: true
      },
      error: {
        nom: ''
      }
    };
  },
  methods: {
    async fetchDuree() {
      try {
        const { data } = await api.getItem('durees', this.$route.params.id);
        // Conversion du Proxy en objet simple pour éviter l'erreur
        this.duree = JSON.parse(JSON.stringify(data));
      } catch (err) {
        console.error('Erreur lors du chargement :', err);
        alert('Impossible de charger la durée.');
        this.$router.push({ name: 'liste_duree_medicament' });
      } finally {
        this.isLoading = false;
      }
    },
    validateForm() {
      this.error.nom = this.duree.nom ? '' : 'Le libellé est requis';
      return !this.error.nom;
    },
    async updateDuree() {
      if (!this.validateForm() || this.isLoading) return;
      try {
        this.isLoading = true;
        const payload = JSON.parse(JSON.stringify(this.duree));
        await api.updateItem('durees', this.$route.params.id, payload);
        alert('Durée mise à jour avec succès !');
        this.$router.push({ name: 'liste_duree_medicament' });
      } catch (err) {
        console.error('Erreur lors de la mise à jour :', err);
        alert(err.response?.data?.detail || "Une erreur s'est produite lors de la mise à jour.");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'liste_duree_medicament' });
    }
  },
  created() {
    this.fetchDuree();
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}
.form-control-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>
